import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FlashMessage from './FlashMessage';

import './styles/FlashMessage.scss';

const FlashRoot = ({ flashMessages: { stack } }) => (
  <div className='flash-container'>
    { stack.map((props, i) => <FlashMessage key={i} {...props} dismissible={false} />) }
  </div>
);

FlashRoot.propTypes = {
  flashMessages: PropTypes.shape({
    stack: PropTypes.arrayOf(PropTypes.shape(FlashMessage.propTypes))
  })
};

FlashRoot.defaultProps = {
  flashMessages: { stack: [] }
};

const mapStateToProps = ({ flashMessages }) => ({
  flashMessages
});

export default connect(mapStateToProps)(FlashRoot);
